import React from "react";
import { PaymentTemplate } from "../../Templates/PaymentTemplate";

export const Payment = () => {
  return <PaymentTemplate />;
};
